import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";

/**
 * PostHog Pageview Tracker
 *
 * Tracks page views for SPA routing. Listens to react-router location changes
 * and fires $pageview events to PostHog.
 */
export function PostHogPageviewTracker() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview", {
        $current_url: window.location.href,
      });
    }
  }, [location.pathname, posthog]);

  return null;
}
